import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "424fe06b-552d-4e6c-b865-26fd1e504d41",
  publicId: "19",
  name: "Waveguides",
  difficulty: 3,
  contentTypes: { audio: false, interactive: true, video: true },
  body: [principle01, principle02, task01],
};

export default lesson;
